import React from "react";

interface State {
  error: Error | null;
  componentStack: string | null;
}

export default class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, State> {
  state: State = { error: null, componentStack: null };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ componentStack: info.componentStack ?? null });
    console.error("[Zekay] Erreur non gérée dans le rendu React", error, info.componentStack);
  }

  private handleClearAndReload = () => {
    try {
      localStorage.removeItem("userSession");
    } catch {}
    try {
      localStorage.removeItem("userCompanies");
    } catch {}
    window.location.reload();
  };

  render() {
    const { error, componentStack } = this.state;
    if (error) {
      return (
        <div
          style={{
            padding: 32,
            fontFamily: "sans-serif",
            color: "#fff",
            background: "#1a1a2e",
            minHeight: "100dvh",
          }}
        >
          <h2>Zekay – Erreur inattendue</h2>
          <p>Une erreur est survenue lors du chargement de l'application.</p>
          <pre
            style={{
              color: "#ff6b6b",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              fontSize: 13,
            }}
          >
            {error.message}
          </pre>
          {componentStack && (
            <details style={{ marginTop: 12 }}>
              <summary style={{ cursor: "pointer", color: "#aaa", fontSize: 13 }}>
                Détails techniques
              </summary>
              <pre
                style={{
                  color: "#aaa",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  fontSize: 11,
                  marginTop: 8,
                }}
              >
                {componentStack}
              </pre>
            </details>
          )}
          <div style={{ display: "flex", gap: 12, marginTop: 20 }}>
            <button
              onClick={() => window.location.reload()}
              style={{ padding: "8px 16px", cursor: "pointer" }}
            >
              Recharger
            </button>
            <button
              onClick={this.handleClearAndReload}
              style={{
                padding: "8px 16px",
                cursor: "pointer",
                background: "#444",
                color: "#fff",
                border: "1px solid #666",
              }}
            >
              Vider la session et recharger
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
